import * as React from "react";
import { CircleCheck, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const features = ["BMS dijagnostika i precizna kalibracija elektroničkog sustava", "Zamjena ćelija isključivo premium Samsung i LG člancima A-klase", "Povećanje kapaciteta i dometa za sve modele električnih romobila", "Točkasto zavarivanje čistim niklom za maksimalnu vodljivost i sigurnost"];
const specifications = [{
  label: "Vrsta usluge",
  value: "Obnova, servis i nadogradnja Li-ion paketa"
}, {
  label: "Korištene ćelije",
  value: "Samsung 35E, LG M50LT, Molicel P42A"
}, {
  label: "Raspon napona",
  value: "36V, 48V, 52V, 60V, 72V sustavi"
}, {
  label: "Kapacitet",
  value: "Od 7.8Ah do 45Ah (ovisno o kućištu)"
}, {
  label: "BMS zaštita",
  value: "Smart BMS s Bluetooth praćenjem parametara"
}, {
  label: "Izolacija",
  value: "Kapton traka i vatrootporni termo-bužiri"
}, {
  label: "Vrijeme izrade",
  value: "3 do 7 radnih dana uz testiranje"
}, {
  label: "Garancija",
  value: "12 mjeseci na sve radove i ugrađene dijelove"
}, {
  label: "Testiranje",
  value: "Potpuni ciklus kapacitivnog testa pod opterećenjem"
}];
export default function ProductDetailsSpecifications() {
  return <section data-section-id="225962" id="specijalizirani-servis-baterija" className="py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
          
          {}
          <div className="flex flex-col">
            <h2 className="text-3xl md:text-4xl font-bold font-default tracking-tight mb-6 text-primary">
              Stručna obnova i servis baterija
            </h2>
            <p className="text-lg text-muted-foreground leading-relaxed mb-8">
              Vaša baterija je srce vašeg romobila. U ChargeZone servisu koristimo najsuvremeniju opremu za dijagnostiku i reparaciju, osiguravajući da vaš uređaj dobije maksimalan domet i sigurnost uz primjenu najviših industrijskih standarda.
            </p>
            
            <div className="mb-10">
              <h3 className="text-xl font-semibold font-default mb-4 text-primary">Ključne prednosti servisa</h3>
              <ul className="space-y-4">
                {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                    <CircleCheck className="size-6 text-primary shrink-0 mt-0.5" />
                    <span className="text-foreground leading-relaxed">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div>
              <Button size="lg" className="gap-2 w-full sm:w-auto bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md">
                <Download className="size-4" />
                Preuzmi cjenik servisa
              </Button>
            </div>
          </div>

          {}
          <div className="rounded-md border border-border bg-card shadow-lg overflow-hidden">
            <div className="p-6 border-b border-border bg-muted/20">
              <h3 className="text-xl font-semibold font-default text-primary">Tehnički parametri i standardi</h3>
              <p className="text-sm text-muted-foreground mt-1">Precizni podaci o procesima i ugrađenim komponentama.</p>
            </div>
            <Table>
              <TableHeader>
                <TableRow className="bg-muted/50 hover:bg-muted/50">
                  <TableHead className="w-[40%] font-semibold font-default text-primary">Parametar</TableHead>
                  <TableHead className="font-semibold font-default text-primary">Detalji</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {specifications.map((spec, i) => <TableRow key={i} data-index={i} className="border-border hover:bg-muted/30">
                    <TableCell className="font-medium text-muted-foreground py-4">
                      {spec.label}
                    </TableCell>
                    <TableCell className="text-foreground py-4 font-default">
                      {spec.value}
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>

        </div>
      </div>
    </section>;
}